import { render, staticRenderFns } from "./productCodeComponent.vue?vue&type=template&id=45f11022&scoped=true&"
import script from "./productCodeComponent.vue?vue&type=script&lang=js&"
export * from "./productCodeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f11022",
  null
  
)

export default component.exports